<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Loon als onderdeel van winst uit onderneming
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om de situatie dat je in loondienst werkt, maar dat je het loon bij de opbrengsten van je
                onderneming telt. Dit mag alleen als er sprake is van:
                <li class="list">een fictieve dienstbetrekking of verloonde inkomsten</li>
                <li class="list">werkzaamheden in loondienst die nauw samenhangen met de werkzaamheden in de eigen onderneming en daaraan
                ondergeschikt zijn</li>
                <li class="list">inkomsten die onder de artiesten- en beroepssportersregeling vallen.</li>
            </div>
        </div>
    </div>

</div>



